import React from 'react'
import s from './GeoentityBlockKeyValue.less'

function renderValues(values) {
  return values.map(({ text, iconUrl }, idx) => {
    return (
      <span key={idx}>
        {idx > 0 ? ' , ' : ''}
        {iconUrl ? <img className={s.image} src={iconUrl} title={text} alt={text} /> : text}
      </span>
    )
  })
}

function KeyValue({ title, values }) {
  return (
    <p className={s.keyValueBlock}>
      {title} : {renderValues(values)}
    </p>
  )
}

export default function GeoentityBlockKeyValue(props) {
  const { data = {} } = props
  const { keyValue = [] } = data
  return keyValue.map(({ key, values }, idx) => <KeyValue key={idx} title={key} values={values} />)
}
